﻿/**
 * How each type renders (classes emitted by `columnType()`, styled in
 * `styles/controls/table.less`). An explicit `align` prop replaces the type's
 * class entirely, so it overrides both alignment AND the sizing behavior below.
 */
export enum TableColumnType {
	/**
	 * No class. Left-aligned; column shrinks to its content (`width: 1px` +
	 * `min-inline-size: fit-content`) and never wraps (`white-space: nowrap`).
	 */
	Undefined,

	/**
	 * `.text` — left-aligned, flexible width: exempt from the shrink-to-content
	 * rule, so it absorbs the table's remaining width and wraps normally.
	 */
	Text,

	/**
	 * `.truncated-text` — left-aligned, flexible width like Text, but
	 * `max-width: 0` drops the content-based preferred width so the cell
	 * truncates with an ellipsis on a single `nowrap` line instead of growing.
	 */
	TruncatedText,

	/** `.number` — right-aligned; shrinks to content, no wrapping. */
	Number,

	/** `.date` — right-aligned; shrinks to content, no wrapping. */
	Date,

	/** `.bool` — center-aligned; shrinks to content, no wrapping. */
	Boolean,

	/**
	 * `.actions` — right-aligned, shrinks to content. Cell padding is collapsed
	 * (header `padding: 0`, body only right inline padding); the cell's `<span>`
	 * of icon buttons is `visibility: hidden` until the row is hovered.
	 */
	Actions,

	/**
	 * `.shrink` — left-aligned; never narrower than its content on a single line
	 * (`min-inline-size: fit-content` + `nowrap`), but with no fixed width it
	 * expands freely when the table has spare space. A middle ground between
	 * Undefined (content width, squeezed to 1px) and Text (flexible, wraps).
	 */
	NoWrap
}
